export default __webpack_public_path__ + "static/media/flycash.8e7a819f.svg";